import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import exact from 'prop-types-exact'
import classnames from 'classnames'
import useClickAway from '../../hooks/useClickAway'
import {
  blacklistSource,
  unblacklistSource,
  subscribeSource,
  unSubscribeSource,
} from '../userActions'
import './sourceItem.pcss'

const SourceItem = ({ source, isBlacklisted, isSubscribed, dispatch }) => {
  const [showMenu, setShowMenu] = useState(false)
  const sourceOptionsMenuRef = useRef(null)

  useClickAway(sourceOptionsMenuRef, () => {
    setShowMenu(false)
  })

  const handleToggleClick = () => {
    setShowMenu(!showMenu)
  }

  const handleSourceBlacklist = () => {
    dispatch(blacklistSource(source.id))
    setShowMenu(false)
  }

  const handleSourceUnblacklist = () => {
    dispatch(unblacklistSource(source.id))
    setShowMenu(false)
  }

  const handleShowPaywallItems = () => {
    dispatch(subscribeSource(source.id))
    setShowMenu(false)
  }

  const handleHidePaywallItems = () => {
    dispatch(unSubscribeSource(source.id))
    setShowMenu(false)
  }

  // Icon modified from https://fontawesome.com/v5/icons/euro-sign?f=classic&s=solid
  return (
    <div className={ classnames('source-item', { 'source-item--open': showMenu }) } ref={ sourceOptionsMenuRef }>
      <a
        className={ classnames('source-item__link', { 'source-item__link--blacklisted': isBlacklisted }) }
        href={ source.link }
        target='_blank'
        rel='noopener noreferrer'
        title={ `Lähteen ${source.name} kotisivu` }
      >
        { source.name }
      </a>

      <button
        className={ classnames('source-item__toggle', { 'source-item__toggle--blacklisted': isBlacklisted }) }
        type='button'
        onClick={ handleToggleClick }
        aria-label={ `Muokkaa lähteen ${source.name} asetuksia` }
        title={ `Muokkaa lähteen ${source.name} asetuksia` }
      >
        { isBlacklisted &&
          <span>Piilotettu</span>
        }
        { source.hasPaywall && !isBlacklisted && isSubscribed &&
          <React.Fragment>
            <svg viewBox='0 0 264 264' xmlns='http://www.w3.org/2000/svg' width='15' height='15'>
              <circle fill='#1577AA' cx='132' cy='132' r='130' />
              <path fill='#fff' d='M 156.886 189.633 C 156.395 187.15 153.951 185.532 151.468 186.097 C 147.444 187 141.16 188.128 134.389 188.128 C 113.02 188.128 96.054 175.038 88.68 156.001 L 131.454 156.001 C 133.569 155.999 135.398 154.529 135.856 152.465 L 138.264 141.782 C 138.903 138.96 136.758 136.288 133.862 136.288 L 83.338 136.288 C 82.887 130.908 82.812 125.641 83.375 120.413 L 138.564 120.413 C 140.678 120.41 142.509 118.939 142.965 116.876 L 145.411 105.666 C 146.013 102.844 143.869 100.173 141.009 100.173 L 88.981 100.173 C 96.732 83.243 112.569 71.958 133.223 71.958 C 138.678 71.958 143.982 72.823 147.48 73.5 C 149.813 73.989 152.108 72.559 152.748 70.265 L 157.262 53.561 C 157.939 51.041 156.322 48.446 153.763 47.956 C 149.174 47.091 141.837 46 133.9 46 C 97.37 46 67.838 68.684 56.966 100.173 L 44.515 100.173 C 42.032 100.173 40 102.204 40 104.687 L 40 115.899 C 40 118.381 42.032 120.413 44.515 120.413 L 52.64 120.413 C 52.264 125.529 52.189 131.434 52.564 136.288 L 44.515 136.288 C 42.032 136.288 40 138.32 40 140.802 L 40 151.486 C 40 153.97 42.032 156.001 44.515 156.001 L 55.838 156.001 C 65.243 189.972 94.661 214.538 133.9 214.538 C 143.793 214.538 152.183 212.845 156.886 211.604 C 159.218 211.002 160.647 208.706 160.197 206.337 L 156.886 189.596 L 156.886 189.633 Z' />
            </svg>
            <span className='source-item__paywall-status'>Näytetään maksulliset jutut</span>
          </React.Fragment>
        }
        { source.hasPaywall && !isBlacklisted && !isSubscribed &&
          <React.Fragment>
            <svg viewBox='0 0 264 264' xmlns='http://www.w3.org/2000/svg' width='15' height='15'>
              <circle fill='#FD5D5D' cx='132' cy='132' r='130' />
              <path fill='#fff' d='M 156.886 189.633 C 156.395 187.15 153.951 185.532 151.468 186.097 C 147.444 187 141.16 188.128 134.389 188.128 C 113.02 188.128 96.054 175.038 88.68 156.001 L 131.454 156.001 C 133.569 155.999 135.398 154.529 135.856 152.465 L 138.264 141.782 C 138.903 138.96 136.758 136.288 133.862 136.288 L 83.338 136.288 C 82.887 130.908 82.812 125.641 83.375 120.413 L 138.564 120.413 C 140.678 120.41 142.509 118.939 142.965 116.876 L 145.411 105.666 C 146.013 102.844 143.869 100.173 141.009 100.173 L 88.981 100.173 C 96.732 83.243 112.569 71.958 133.223 71.958 C 138.678 71.958 143.982 72.823 147.48 73.5 C 149.813 73.989 152.108 72.559 152.748 70.265 L 157.262 53.561 C 157.939 51.041 156.322 48.446 153.763 47.956 C 149.174 47.091 141.837 46 133.9 46 C 97.37 46 67.838 68.684 56.966 100.173 L 44.515 100.173 C 42.032 100.173 40 102.204 40 104.687 L 40 115.899 C 40 118.381 42.032 120.413 44.515 120.413 L 52.64 120.413 C 52.264 125.529 52.189 131.434 52.564 136.288 L 44.515 136.288 C 42.032 136.288 40 138.32 40 140.802 L 40 151.486 C 40 153.97 42.032 156.001 44.515 156.001 L 55.838 156.001 C 65.243 189.972 94.661 214.538 133.9 214.538 C 143.793 214.538 152.183 212.845 156.886 211.604 C 159.218 211.002 160.647 208.706 160.197 206.337 L 156.886 189.596 L 156.886 189.633 Z' />
            </svg>
            <span className='source-item__paywall-status'>Maksulliset jutut piilotettu</span>
          </React.Fragment>
        }
        <i className={ showMenu ? 'fa fa-chevron-up' : 'fa fa-chevron-down' } aria-hidden='true' />
      </button>

      { showMenu ?
        <div className='source-item__menu-container'>

          { source.hasPaywall ? (
            !isSubscribed ?
              <button
                type='button'
                className={ classnames('source-item__menu-container-button', { 'error': isBlacklisted }) }
                disabled={ isBlacklisted }
                title={ isBlacklisted ? 'Lähde on piilotettu' : 'Näytä lähteen maksumuurijutut' }
                onClick={ handleShowPaywallItems }
              >
                <span className='source-item__menu-container-button-text'>Näytä lähteen maksulliset jutut</span>
              </button> :
              <button
                type='button'
                className={ classnames('source-item__menu-container-button', { 'error': isBlacklisted }) }
                disabled={ isBlacklisted }
                onClick={ handleHidePaywallItems }
              >
                Piilota lähteen maksulliset jutut
              </button>
          ) : null
          }

          { isBlacklisted ?
            <button type='button' className='source-item__menu-container-button' onClick={ handleSourceUnblacklist }>
              Näytä lähde uutislistoilla
            </button> :
            <button type='button' className='source-item__menu-container-button' onClick={ handleSourceBlacklist }>
              Piilota lähde uutislistoilla
            </button>
          }

        </div> : null
      }

    </div>
  )
}

SourceItem.propTypes = exact({
  source: ImmutablePropTypes.record.isRequired,
  isBlacklisted: PropTypes.bool.isRequired,
  isSubscribed: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
})

export default SourceItem
